"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  qualityFile: {
    home: {
      enterFileNo: '请输入编号或名称关键字'
    },
    index: {
      title: 'HSQE文件维护',
      item: '文件维护',
      pleaseEnter: '请输入必填项',
      moduleCodingDuplication: '模块编码重复！',
      fileNo: '文件编号',
      fileName: '文件名',
      enterFileNo: '请输入文件编号',
      enterFileName: '请输入文件名称',
      button: {
        editCatalog: '目录维护',
        editVersion: '版本维护',
        addQualityFile: '新增文件',
        editQualityFile: '文件换版',
        editCatalogHistory: '体系变更记录',
        btnPublish: '发布',
        fileSearch: '文件搜索'
      },
      query: {
        itemName: '项目名称',
        vesselControlledFile: '船舶支持性文件',
        controlledFile: '文件管理',
        controlledRecord: '记录表格',
        otherControledFile: '文件管理',
        otherControlledDocuments: '文件目录'
      },
      table: {
        qualityFileNo: '编号',
        qualityFileName: '名称',
        qualityVersion: '版本号',
        source: '文件来源',
        qualityType: '文件类型',
        qualityStatus: '文件状态',
        publishDate: '发布日期',
        relatedAttach: '相关附件',
        qualityReviseVersion: '修订版本号',
        qualityFileDate: '生效日期',
        qualityDueDate: '失效日期',
        sysPostId: '涉及岗位',
        qualityFileStatus: '状态',
        qualityFileInfoId: '关联文件',
        qualityRecordInfoId: '关联表格',
        name: '名称',
        initiateSystemImprovement: '发起体系改进'
      }
    },
    editQualityFile: {
      tab: {
        fileInformation: '文件信息',
        recordInformation: '记录信息',
        historicalVersion: '历史版本'
      },
      form: {
        taskAssign: '学习任务分派',
        yes: '是',
        no: '否',
        examFlag: '是否考试',
        fileRootId: '文件标识',
        qualityCatalog: '体系目录',
        qualityRecordVersion: ' 版本号',
        qualityReviseVersion: '修订版本号',
        qualityReviseEditVersion: '修订版本号',
        attachInfo: '附件(必须包括中、英文)',
        operateType: '操作类型',
        qualityFileNo: '文件编号',
        qualityFileDate: '生效日期',
        qualityFileNameCn: '中文名称',
        qualityFileNameEn: '英文名称',
        createOffice: '编制部门',
        syncFlag: '是否船岸同步',
        sysOrgId: '涉及部门',
        sysPostId: '涉及岗位',
        shipPostId: '船端岗位',
        sysVesselType: '适用船型',
        relaxQualityFile: '关联文件',
        relaxRecord: '相关记录',
        standardInfoId: '所属标准',
        mainBody: '正文',
        upMainBody: '上传正文',
        attachmentsInfoId: '附件',
        uploadAttachment: '上传附件',
        updateContext: '更新内容',
        taskName: '任务名称',
        learnFlag: '是否学习',
        learnDeadline: '学习完成日期',
        learnDept: '学习部门',
        learnShip: '学习船舶',
        ship: '船舶',
        learnRemark: '学习要求',
        feedBack: '学习后反馈',
        shoreLearnPost: '岸端学习岗位',
        shipLearnPost: '船端学习岗位',
        qualityFileName: '名称',
        qualityDueDate: '失效日期',
        monitorPost: '监控岗位',
        monitorDept: '监控部门',
        remindDate: '填报提醒',
        inputCircle: '填报周期',
        circleFlag: '周期性提醒',
        monitorRemind: '监控提醒',
        tableTemplate: '表格模板'
      }
    },
    editCatalog: {
      item: '体系目录',
      table: {
        catalogNameCn: ' 目录名称 ',
        lastModifyTime: '更新日期',
        catalogRemark: '备注'
      },
      form: {
        parentName: ' 上级目录 ',
        catalogName: '目录名称',
        catalogNameCn: '目录中文名称',
        catalogNameEn: '目录英文名称',
        dispOrder: '显示顺序',
        catalogRemark: '备注',
        catalogType: '类型'
      }
    },
    editVersion: {
      item: '体系版本',
      table: {
        sysOrgId: ' 公司名称 ',
        qualityRecordVersion: '版本号',
        relaxRecord: '相关记录',
        qualityFileDate: '生效日期',
        remarks: '备注'
      },
      form: {
        sysOrgId: ' 所属公司 ',
        qualityRecordVersion: '版本号',
        qualityFileDate: '生效日期',
        remarks: '备注'
      }
    },
    catalogHistory: {
      item: '体系变更记录',
      table: {
        qualityFileNo: '文件编号',
        qualityFileName: '文件名称',
        qualityVersion: '版本号',
        qualityReviseVersion: '修订版本号',
        qualityFileDate: '生效日期',
        sysOrgId: '修改部门',
        updateContext: '更新内容',
        approve: '批准',
        reviser: '修改人'
      }
    },
    updateContext: {
      item: '替换正文',
      optionDoc: '选择文件',
      table: {
        context: '正文（PDF）',
        reviseContext: '正文(PDF修订版)',
        contextEn: '英文正文(PDF)',
        reviseContextEn: '英文正文(PDF修订版)',
        associatedFile: '关联文件',
        associatedTable: '关联表格'
      }
    },
    title: {
      replaceFile: '替换文件',
      modifyTestQuestions: '修改试题'
    },
    msg: {
      saveSuccess: '保存成功'
    }
  },
  qualityRecord: {
    index: {
      title: 'HSQE文件维护',
      item: '记录表格维护',
      learningRecordQuery: '学习记录查询',
      requiredCompletionDate: '要求完成日期',
      query: {
        itemName: '项目名称'
      },
      table: {
        taskType: '任务类型',
        filePath: '文件路径',
        feedbackContent: '反馈内容',
        attachment: '附件',
        qualityRecordNo: '记录编号',
        qualityRecordName: '名称',
        qualityRecordNameCn: '名称(中文)',
        qualityRecordNameEn: '名称(英文)',
        qualityRecordVersion: '版本号',
        qualityReviseVersion: '修订版本号',
        qualityRecordDate: '生效日期',
        qualityDueDate: '失效日期',
        sysPostId: '涉及岗位',
        validFlag: '状态',
        recordLocation: '存放地点',
        recordSaveTime: '保存期限',
        attachmentsName: '所属文件',
        eventInfoId: '所属活动',
        relatedBusiness: '关联业务',
        fileName: '名称',
        enterFileName: '请输入名称',
        fileNo: '编号',
        fileNoName: '文件编号/名称',
        taskName: '任务名称',
        enterFileNo: '请输入编号',
        companyName: '所属公司',
        enterCompany: '请选择所属公司'
      }
    },
    editQualityRecord: {
      form: {
        yes: '是',
        no: '否',
        recordRootId: '记录标识',
        qualityRecordNo: '记录编号',
        qualityRecordVersion: '版本号',
        qualityReviseVersion: '修订版本号',
        editType: '修改类型',
        qualityRecordNameCn: '记录中文名称',
        qualityRecordNameEn: '记录英文名称',
        qualityRecordDate: '生效日期',
        recordSaveTime: '保存期限',
        syncFLag: '是否船岸同步',
        qualityRecordDept: '编制部门',
        sysOrgId: '涉及部门',
        sysPostId: ' 涉及岗位 ',
        qualityFileId: '所属文件',
        standardInfoId: '所属标准',
        eventInfoId: '所属活动',
        recordLocation: '存放地点',
        relatedBusiness: '关联业务',
        mainBodyCn: '正文(中文)',
        mainBodyEn: '正文(英文)',
        uploadAttachment: '上传文件',
        tableTemplate: '表格模板',
        addTitle: '新增表格',
        editTitle: '编辑表格',
        queryTitle: '查看表格',
        circleFlag: '周期性提醒'
      }
    }
  },
  benchmark: {
    index: {
      title: 'HSQE文件维护',
      item: '体系对标',
      query: {
        itemName: '项目名称'
      },
      table: {
        qualityFileName: '文件名称',
        qualityFileNo: '文件编号',
        qualityFileDate: '生效日期',
        qualityDueDate: '失效日期'
      }
    }
  },
  standard: {
    index: {
      title: 'HSQE文件维护',
      item: '标准管理',
      query: {
        itemName: '项目名称',
        keyContent: '标准/节点内容'
      },
      table: {
        index: '序号',
        standardCode: '编号',
        standardContent: '内容',
        relationFileChapter: '统计分类'
      }
    },
    standardDialog: {
      form: {
        maxLength: '最多输入十个字符',
        standardStatus: '标准状态',
        effective: '有效',
        loseEfficacy: '失效',
        parentName: '父类名称',
        standardType: '类型',
        standard: '标准',
        node: '节点',
        standardCode: '标准编号',
        dispOrder: '显示顺序',
        standardNameCn: '标准中文名称',
        standardNameEn: '标准英文名称',
        standardContent: '内容',
        qualityFileChapter: '章节号',
        rootId: '上级节点',
        statisticId: '统计分类'
      }
    }
  },
  qualityFileBusiness: {
    index: {
      title: 'HSQE文件维护',
      item: '文件关联业务',
      belongOrgName: '所属公司',
      fileAll: '文件名称',
      addFileModuleBtn: '新增业务模块',
      addFielBusinessBtn: '新增文件关系',
      query: {
        fileAll: '请输入内容'
      },
      businessTable: {
        index: '序号',
        moduleName: '业务模块'
      },
      businessRelateTable: {
        index: '序号',
        fileNo: '文件编号',
        fileName: '文件名称',
        fileOtherName: '文件别名',
        fileType: '文件类型',
        sortNo: '显示顺序',
        belongOrgName: '所属公司'
      }
    },
    editBusinessModuleDialog: {
      module: '模块',
      task: '任务',
      activity: '活动',
      item: '业务模块维护',
      form: {
        moduleParentName: '父模块',
        moduleCode: '模块编码（唯一）',
        moduleName: '模块名称',
        moduleNameCn: '模块名称（中文）',
        moduleNameEn: '模块名称（英文）',
        dispOrder: '显示顺序',
        moduleRemark: '备注'
      },
      formRules: {
        moduleName: '模块名称不能为空',
        moduleNameCn: '模块名称（中文）不能为空',
        moduleNameEn: '模块名称（英文）不能为空',
        moduleCode: '模块编码不能为空且必须唯一'
      }
    },
    editBusinessFileDialog: {
      item: '文件关联业务配置',
      form: {
        companyId: '所属公司',
        moduleId: '业务模块',
        qualityFileType: '文件类型',
        dispOrder: '显示顺序',
        qualityFileId: '关联文件',
        qualityFileNameCn: '文件别名（中文）',
        qualityFileNameEn: '文件别名（英文）'
      }
    }
  },
  qualityFileHome: {
    index: {
      item: '体系文件',
      Document: '体系文件',
      CircularFile: '公司通告',
      ExternalFile: '外部资料法规',
      BestPractices: '最佳实践',
      ControlledDocument: '其它受控文件'
    }
  },
  otherFileHome: {
    index: {
      title: 'HSQE文件维护',
      item: '其他文件查询',
      noesRegulations: '通告与法规',
      fileCode: '编号',
      fileName: '名称',
      fileStatus: '状态',
      fileValidDate: '生效日期',
      table: {
        fileCode: '编号',
        fileName: '名称',
        fileStatus: '状态',
        fileValidDate: '生效日期',
        fileAttach: '附件',
        uploader: '上传人',
        uploadDate: '上传日期'
      }
    }
  },
  integratedQuery: {
    title: '综合查询',
    index: {
      filter: {
        pleaseSelect: '请选择',
        company: '所属公司',
        activityType: '活动类型',
        recordName: '记录名称',
        vessel: '涉及船舶',
        scope: '填报周期',
        deptOrVessel: '发起部门/船舶',
        activityStatus: '活动状态',
        activityDate: '活动日期',
        voyageNo: '航次号'
      },
      table: {
        activityType: '活动类型',
        recordName: '记录名称',
        scope: '填报周期',
        deptOrVessel: '发起部门/船舶',
        initiatePerson: '发起人',
        activityDate: '活动日期',
        vessel: '涉及船舶',
        saveLocation: '存放位置',
        saveDate: '保存期限',
        eventCode: '活动编码',
        voyageNo: '航次号',
        status: '状态'
      }
    }
  },
  qualityActivity: {
    index: {
      title: '体系运行',
      item: '业务活动配置',
      belongOrgName: '所属公司',
      activityAll: '记录编号/名称',
      addFileModuleBtn: '新增活动',
      addActivityBusinessBtn: '新增',
      query: {
        activityAll: '请输入内容'
      },
      businessTable: {
        index: '序号',
        moduleName: '业务模块'
      },
      businessRelateTable: {
        index: '序号',
        activityNo: '记录编号',
        activityName: '记录名称',
        activityType: '活动类型',
        businessRouterUrl: '工作填报路由地址',
        searchRouterUrl: '综合查询路由地址',
        wfCode: '流程编码',
        syncFlag: '是否同步',
        sortNo: '显示顺序',
        companyName: '所属公司'
      }
    },
    editBusinessModuleDialog: {
      module: '模块',
      task: '任务',
      activity: '活动',
      item: '业务模块维护',
      form: {
        company: '所属公司',
        moduleType: '类型',
        parentId: '父级节点',
        activityName: '活动名称',
        activityNameEn: '活动英文名称',
        dispOrder: '显示顺序',
        moduleRemark: '备注'
      },
      formRules: {
        parentId: '请选择父节点',
        activityName: '请填写活动名称',
        activityNameEn: '请填写活动英文名称',
        moduleType: '请选择类型'
      }
    },
    editBusinessFileDialog: {
      item: '活动关联记录表格',
      attchForm: '附件形式',
      textForm: '文本形式',
      moduleForm: '模板形式',
      form: {
        businessRouterUrl: '工作填报路由地址',
        searchRouterUrl: '综合查询路由地址',
        companyId: '所属公司',
        moduleId: '业务活动',
        qualityFileType: '记录表格',
        inputTemplateUrl: '页面加载地址',
        mobile: '是否支持移动端',
        inputType: '界面加载方式',
        dispOrder: '显示顺序',
        wfFlag: '是否走流程',
        wfCode: '流程编码',
        syncFlag: '是否船岸同步',
        qualityEvent: '关联活动',
        qualityFileNameCn: '文件别名（中文）',
        qualityFileNameEn: '文件别名（英文）'
      },
      rules: {
        wfFlag: '请选择是否走流程',
        businessRouterUrl: '请填写工作填报路由地址',
        searchRouterUrl: '请选择综合查询路由地址',
        syncFlag: '请选择是否船岸同步',
        inputType: '请选择界面加载形式',
        wfCode: '请填写流程编码',
        inputTemplateUrl: '请填写页面加载地址'
      }
    }
  }
};